import { FC } from 'react'
import { useFormContext } from 'react-hook-form'
import EXTRA_QUESTION_LABELS from '../../../../constants/extraQuestions'
import { Label } from '../../../../shared/compass-ui'
import ControlledNumericInput from '../../../shared/ControlledNumericInput'
import TextInputError from '../../../shared/TextInputError'

const RecentAccountsOpened: FC = () => {
  const {
    formState: {
      errors: { recentAccountsOpened: recentAccountsOpenedError },
    },
  } = useFormContext()

  return (
    <div className="col-span-full md:col-span-3">
      <Label htmlFor="recent-accounts-opened-input">
        {EXTRA_QUESTION_LABELS.recentAccountsOpened}
      </Label>
      <ControlledNumericInput name="recentAccountsOpened" id="recent-accounts-opened-input" />
      {typeof recentAccountsOpenedError?.message === 'string' && (
        <TextInputError>{recentAccountsOpenedError.message}</TextInputError>
      )}
    </div>
  )
}

export default RecentAccountsOpened
